import { getSubcategories } from '@/features/org/api/get-organization-categories';
import { useOrganizationCategories } from '@/features/org/hooks/use-organization-categories';

export const useOrganizationSubcategories = (categoryId?: string) => {
  const { categories, isLoading: isCategoriesLoading } =
    useOrganizationCategories();

  const subcategoryIds = categoryId
    ? getSubcategories(categories, categoryId)
    : [];

  return {
    subcategoryIds,
    isLoading: isCategoriesLoading,
  };
};
